import { PaginateParamsRequest } from 'types/common';

export const initialParams: PaginateParamsRequest = {
    pageSize: 10,
    page: 0,
    orderBy: 'createdDate',
    sortingOrder: 1,
};
